// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {img_url} from '../../ui/img_url';
import {Settings_context} from '../../settings_ctx';
import {Button} from '../../lib/button';
import {Link} from 'react-router-dom';
import styles from './404_new.module.less';

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={theme.root}>
      <div className={cn(theme.container, styles.not_found)}>
        <img src={img_url('hola2023/404_island_bg.svg')} alt="404"
          className="lazyload"/>
        <h1 className={theme.H4}>Well this is awkward...</h1>
        <p className={theme.p2}>
          The page you were trying to reach doesn't exist anymore, or maybe it
          has just moved. Feel free to <Link to="/contact"
          className={theme.link}>contact us</Link> if the problem persists
          or if you can't find what you are looking for.
        </p>
        <Button to="/" caption="Go to Hola homepage"/>
      </div>
    </div>;
};
Root.meta = {
    footless: true,
    headlogo: true,
    default_theme: 'hola2023',
    no_ssr: true,
    meta: {
        title: 'Hola | 404 Page not found',
        robots: 'noindex',
    },
};
